import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, X } from "lucide-react";

const KEY = "nq-surplus-banner-dismissed-v2";

/**
 * Site-wide surplus stock banner. Dismissible, and it stays dismissed - a repeat
 * customer shouldn't be shouted at on every visit.
 */
export default function AnnouncementBar() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(window.localStorage.getItem(KEY) !== "1");
  }, []);

  if (!show) return null;

  return (
    <div
      className="relative overflow-hidden border-b"
      style={{
        background: "linear-gradient(90deg, #17110250 0%, #C6A24A18 50%, #17110250 100%)",
        borderColor: "rgba(198,162,74,0.28)",
      }}
      data-testid="announcement-bar"
    >
      <div className="container-nq flex items-center justify-center gap-3 py-2 pr-8 text-center">
        <Link
          to="/shop"
          className="group flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5 text-[11px] font-semibold uppercase tracking-[0.14em] sm:text-xs"
          data-testid="announcement-bar-link"
        >
          <span className="gold-text">Surplus stock at COST PRICE</span>
          <span className="text-[color:var(--nq-stone)] normal-case tracking-normal">
            no markups, we're wearing the fees
          </span>
          <ArrowRight className="h-3.5 w-3.5 gold-text transition-transform group-hover:translate-x-0.5" />
        </Link>
      </div>
      <button
        type="button"
        aria-label="Dismiss"
        onClick={() => {
          window.localStorage.setItem(KEY, "1");
          setShow(false);
        }}
        className="absolute right-2 top-1/2 -translate-y-1/2 rounded p-1.5 text-[color:var(--nq-stone)] transition hover:bg-white/5 hover:text-[color:var(--nq-sand)]"
        data-testid="announcement-bar-dismiss"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
